// Generated by scripts/write-yinsh-replay-fixtures.ts.
// Do not edit manually.

import type { YinshReplayEventType } from "./event-adapter";

export interface YinshReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface YinshReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: YinshReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface YinshReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "yinsh";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly players: readonly YinshReplayFixturePlayer[];
  readonly events: readonly YinshReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const YINSH_REPLAY_FIXTURES: Record<string, YinshReplayFixture> = {
  "simple-2p-live": {
    schemaVersion: 1,
    gameType: "yinsh",
    scenario: "simple-2p-live",
    source: "generated",
    capturedAt: "2026-06-07T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "White",
        role: "host",
      },
      {
        id: "p2",
        name: "Black",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            phase: "RING_PLACEMENT",
            turn: 1,
            currentPlayer: "WHITE",
            players: [
              {
                color: "WHITE",
                name: "White",
                ringsOnBoard: 0,
                ringsScored: 0,
              },
              {
                color: "BLACK",
                name: "Black",
                ringsOnBoard: 0,
                ringsScored: 0,
              },
            ],
            board: {},
            markersPool: 51,
            winner: null,
            isDraw: false,
            pendingRows: [],
            opponentPendingRows: [],
            rowsRemovedThisTurn: 0,
            markerPlacedAt: null,
            lastMover: null,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "place_ring",
        userId: "p1",
        payload: {
          player: "WHITE",
          position: "e1",
        },
      },
      {
        sequenceNumber: 3,
        eventType: "place_ring",
        userId: "p2",
        payload: {
          player: "BLACK",
          position: "f2",
        },
      },
      {
        sequenceNumber: 4,
        eventType: "place_ring",
        userId: "p1",
        payload: {
          player: "WHITE",
          position: "e3",
        },
      },
      {
        sequenceNumber: 5,
        eventType: "place_ring",
        userId: "p2",
        payload: {
          player: "BLACK",
          position: "f4",
        },
      },
      {
        sequenceNumber: 6,
        eventType: "place_ring",
        userId: "p1",
        payload: {
          player: "WHITE",
          position: "e5",
        },
      },
      {
        sequenceNumber: 7,
        eventType: "place_ring",
        userId: "p2",
        payload: {
          player: "BLACK",
          position: "f6",
        },
      },
      {
        sequenceNumber: 8,
        eventType: "place_ring",
        userId: "p1",
        payload: {
          player: "WHITE",
          position: "e7",
        },
      },
      {
        sequenceNumber: 9,
        eventType: "place_ring",
        userId: "p2",
        payload: {
          player: "BLACK",
          position: "f8",
        },
      },
      {
        sequenceNumber: 10,
        eventType: "place_ring",
        userId: "p1",
        payload: {
          player: "WHITE",
          position: "e9",
        },
      },
      {
        sequenceNumber: 11,
        eventType: "place_ring",
        userId: "p2",
        payload: {
          player: "BLACK",
          position: "f10",
        },
      },
      {
        sequenceNumber: 12,
        eventType: "take_turn",
        userId: "p1",
        payload: {
          player: "WHITE",
          ringPosition: "e1",
          destination: "e2",
        },
      },
      {
        sequenceNumber: 13,
        eventType: "forfeit",
        userId: "p2",
        payload: {
          player: "BLACK",
        },
      },
    ],
    notes: [
      "YINSH is a public-information game; replay renders canonical engine state directly (no viewer-state projection).",
      "Fixture: init -> 10 ring placements -> one playing turn (take_turn) -> forfeit to reach GAME_END.",
      "Final state: phase GAME_END, winner WHITE.",
    ],
  },
};
